import React, { useState, useMemo, useEffect } from "react";
import { useLocation } from "react-router-dom";
import BreadCrumb from "../Components/BreadCrumb";
import Spinner from "../Components/Spinner";
import { flattenMenus } from "../../../Utility/FlattenMenu";
import { useGetFooterMenusDataQuery } from "../../../redux/services/internal/apiHome";
import { replaceBaseUrl } from "./MenuPage";

const FooterMenuPage = ({ benchId }) => {
  const location = useLocation();
  const path = location.pathname;
  const menuPath = path.split("/").pop();

  const [filteredMenu, setFilteredMenu] = useState([]);

  // Fetch data from the API
  const { data: fetchedData = {}, isLoading } = useGetFooterMenusDataQuery(7);

  const transformedData = useMemo(() => {
    return fetchedData.data ? flattenMenus(fetchedData.data) : [];
  }, [fetchedData.data]);

  useEffect(() => {
    if (transformedData.length > 0) {
      const filteredPageData = transformedData.filter(
        (item) => item.slug === menuPath,
      );
      setFilteredMenu(filteredPageData);
    }
  }, [transformedData, menuPath]);

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <>
      <div className="col-12 col-sm-12 col-md-9 col-lg-9">
        {filteredMenu.length > 0 ? (
          <>
            {filteredMenu.map((item, index) => (
              <React.Fragment key={index}>
                <BreadCrumb title={filteredMenu[0].title || "Default Title"} />
                <div className="about-bg inner-page-section">
                  <div className="container">
                    <div className="row">
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="about-content">
                          <div className="underline"></div>
                          <div className="main-contain">
                            <div className="container">
                              <div className="row">
                                <div className="col-12 p-0">
                                  <div
                                    // dangerouslySetInnerHTML={{
                                    //   __html: item.description,
                                    // }}
                                    dangerouslySetInnerHTML={{
                                      __html: replaceBaseUrl(item?.description),
                                    }}
                                  ></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </React.Fragment>
            ))}
          </>
        ) : (
          <p>Loading...</p>
        )}
      </div>
    </>
  );
};

export default FooterMenuPage;
